import $ from 'jquery'
import store from '@/store'
// 拖动改变详情页面宽度
const dialogdragwidth = {
  bind(el, binding, vnode, oldVnode) {
    el.onmousedown = e => {
      store.commit('MULTITEXT_SET_COVER', { time: new Date(), type: 0 }) // 拖动富文本处理
      let clientXCustom = e.clientX
      if (document.body.clientWidth - e.clientX <= 900) {
        clientXCustom = document.body.clientWidth - 900
      }
      let lineEle = `<div class="drog_line_diffpage" style="left:${clientXCustom}px;"></div>`
      $('body').append(lineEle)
      let resultWidth = 900
      $('body').css({ 'user-select': 'none' })
      document.onmousemove = function (e) {
        let startWidth = document.body.clientWidth - e.clientX
        let leftOffset = e.clientX
        if (startWidth <= 900) {
          leftOffset = document.body.clientWidth - 900
          resultWidth = 900
        } else if (e.clientX <= 30) {
          let docWidth = document.body.clientWidth
          resultWidth = docWidth - 30
          leftOffset = 30
        } else {
          resultWidth = startWidth
        }
        setTimeout(() => {
          $('.drog_line_diffpage').css({ left: leftOffset + 'px' })
        }, 15)
      }
      document.onmouseup = function (e) {
        $('body').css({ 'user-select': 'inherit' })
        let dragDom = document.getElementsByClassName(binding.value)
        let diffDetails = document.getElementsByClassName('different-types-details')[0]
        let diffDetails1 = document.getElementsByClassName('.data-detail-task-detail')
        let diffDetails2 = document.getElementsByClassName('personal-task-details')
        let projectPerTask = document.getElementById('projectPersonnlTask_css')
        let moduleDetailLayout = document.getElementsByClassName('custom-module-details-wrip')
        for (let i = 0; i < dragDom.length; i++) {
          dragDom[i].style.width = resultWidth + 'px'
        }
        if (diffDetails) {
          diffDetails.style.width = resultWidth + 'px'
        }
        $('.different-create-pages-wrip').css({ width: resultWidth + 'px' })
        if (projectPerTask) {
          projectPerTask.style.width = resultWidth + 'px'
        }
        if (moduleDetailLayout) {
          $('.custom-module-details-wrip').css({ width: resultWidth + 'px' })
        }
        if (diffDetails1) {
          $('.data-detail-task-detail').css({ width: resultWidth + 'px' })
        }
        if (diffDetails2) {
          $('.personal-task-details').css({ width: resultWidth + 'px' })
        }
        localStorage.setItem('customDetailsWidth', resultWidth + 'px')
        vnode.context.$bus.emit('customDetailsMoreSet', vnode.context.dtlKey)
        $('.drog_line_diffpage').remove()
        vnode.context.$bus.emit('tabHiddenListChange', vnode.context.dtlKey)
        store.commit('MULTITEXT_SET_COVER', { time: new Date(), type: 1 }) // 拖动富文本处理
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
}
// 拖动表格样式，子表单改变子表单内部字段宽度
const draggsubformwidth = {
  bind(el, binding, vnode, oldVnode) {
    el.onmousedown = e => {
      let subformName = binding.value.name
      let className = binding.value.classname
      let offet = $(`.${className}`).offset()
      let dragDom = document.getElementsByClassName(className)
      if (
        className.includes('subformpopwidth') ||
        className.includes('subformwidth') ||
        className.includes('task-subform-width')
      ) {
        $(dragDom).css({
          flex: 'none',
          width: dragDom[0].clientWidth + 'px'
        })
      }
      let str = 'showSubformWidth' + className.split('formwidth')[1]
      let resultWidth = 0
      document.onmousemove = function (e) {
        let width = e.clientX - offet.left
        if (width > 50) {
          resultWidth = width
          $(dragDom).width(width)
          if ($('.' + str)) {
            $('.' + str).html(parseInt(width) + 'px')
          }
        } else {
          resultWidth = 50
          $(dragDom).width(50)
          if ($('.' + str)) {
            $('.' + str).html('50px')
          }
        }
      }
      document.onmouseup = function (e) {
        if (vnode.context.property) {
          vnode.context.$bus.emit(
            'fullScreenSubformEditChange',
            vnode.context.property.name,
            subformName,
            resultWidth
          )
        }
        document.onmousemove = null
        document.onmouseup = null
        $('.show-subform-width-online').html('')
      }
    }
  }
}
// 拖动子表格高度，子表单改变子表单内部字段高度
const draggsubformheight = {
  bind(el, binding, vnode, oldVnode) {
    el.onmousedown = e => {
      let offet = $(`.${binding.value}`).offset()
      let dragDom = document.getElementsByClassName(binding.value)
      let parentClass = $(`.${binding.value}`).parent().parent().attr('class')
      let minHeight = 82
      if (!parentClass.includes('height-double')) {
        minHeight = 42
      }
      document.onmousemove = function (e) {
        let height = e.clientY - offet.top
        if (height > minHeight) {
          $(dragDom).height(height)
        } else {
          $(dragDom).height(minHeight)
        }
      }
      document.onmouseup = function (e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
}

const clickOutside = {
  // 初始化指令
  bind(el, binding, vnode) {
    function clickHandler(e) {
      // 这里判断点击的元素是否是本身，是本身，则返回
      if (el.contains(e.target)) {
        return false
      }
      // 判断指令中是否绑定了函数
      if (binding.expression) {
        // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
        binding.value(e)
      }
    }
    // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
    el.__vueClickOutside__ = clickHandler
    document.addEventListener('click', clickHandler)
  },
  update() {},
  unbind(el, binding) {
    // 解除事件监听
    document.removeEventListener('click', el.__vueClickOutside__)
    delete el.__vueClickOutside__
  }
}
const drag = {
  bind(el, bindings) {
    el.onmousedown = function (e) {
      let disx = e.pageX - el.offsetLeft
      let disy = e.pageY - el.offsetTop
      document.onmousemove = function (e) {
        el.style.left = e.pageX - disx + 'px'
        el.style.top = e.pageY - disy + 'px'
      }
      document.onmouseup = function () {
        document.onmousemove = document.onmouseup = null
      }
    }
  }
}
const dragKanbanwidth = {
  bind(el, binding, vnode, oldVnode) {
    el.onmousedown = e => {
      let dragDom = document.getElementsByClassName(binding.value)[0]
      let navwidth = document.getElementsByClassName('el-menu-vertical-demo')[0].clientWidth + 15
      document.onmousemove = function (e) {
        let parentWidth = document.body.clientWidth
        let startWidth = e.clientX - navwidth
        if (startWidth <= 240) {
          startWidth = 240
          return false
        }
        if (startWidth / parentWidth > 0.5) {
          let widthnew = parentWidth * 0.5
          startWidth = widthnew
          return false
        }
        dragDom.style.width = startWidth + 'px'
        localStorage.setItem('kanbanNavWidth', startWidth)
        document.getElementsByClassName('kanban-icon-aside')[0].style.left = startWidth + 'px'
        document.getElementsByClassName('move-nav-kanban')[0].style.left = startWidth + 'px'
        vnode.context.$bus.emit('setwidthparent', startWidth)
      }
      document.onmouseup = function (e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
}
// 业务流程图
const businessdragwidth = {
  bind(el, binding, vnode, oldVnode) {
    el.onmousedown = e => {
      let dragDom = document.getElementsByClassName(binding.value)
      // let index3 = diffDetails.length
      document.onmousemove = function (e) {
        let startWidth = document.body.clientWidth - e.clientX
        let index = dragDom.length
        if (startWidth <= 900) {
          for (let i = 0; i < index; i++) {
            dragDom[i].style.width = '900px'
          }
          startWidth = 900
          return false
        }
        let docWidth = document.body.clientWidth
        if (startWidth / docWidth > 0.98) {
          let widthnew = docWidth * 0.98
          if (dragDom) {
            for (let i = 0; i < index; i++) {
              dragDom[i].style.width = widthnew + 'px'
            }
          }
          startWidth = widthnew
          return false
        }
        for (let i = 0; i < index; i++) {
          dragDom[i].style.width = startWidth + 'px'
        }
      }
      document.onmouseup = function (e) {
        vnode.context.$bus.emit('updateAntvFlowResize')
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
}
// blur 去除前后空格
const trim = {
  bind(el, binding, vnode, oldVnode) {
    function trigger(element, type) {
      var e = document.createEvent('HTMLEvents')
      e.initEvent(type, true, true)
      element.dispatchEvent(e)
    }
    let node = el.nodeName === 'DIV' ? el.querySelector('input,textarea') : el
    node.onblur = e => {
      let value = e.target.value
      e.target.value = value ? value.trim() : value
      // trigger(node, el.querySelector('input') ? 'input' : 'textarea')
      trigger(node, 'input')
    }
  }
}
// input type="number"滚动阻止改变值，且不影响表单的滚动事件
const stopNumberScroll = {
  bind(el, binding, vnode, oldVnode) {
    let ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
    ele.addEventListener('mousewheel', () => {
      ele.blur()
    })
  },
  unbind(el, binding) {
    // 解除事件监听
    let ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
    ele.removeEventListener('mousewheel', () => {
      ele.blur()
    })
  }
}

// 文件库拖动宽度
const fileLibraryDragwidth = {
  bind(el, binding, vnode, oldVnode) {
    el.onmousedown = e => {
      let resultWidth = 0
      let offet = $(`.${binding.value}`).offset()
      // let dragDom = document.getElementsByClassName(binding.value)
      document.onmousemove = function (e) {
        let width = e.clientX - offet.left
        if (width > 600) {
          // $(dragDom).width(600)
          resultWidth = 600
        } else if (width > 300) {
          resultWidth = width
          // $(dragDom).width(width)
        } else {
          resultWidth = 300
          // $(dragDom).width(320)
        }
        setTimeout(() => {
          if (binding.value === 'file-lirary-left-drag-new') {
            vnode.context.$bus.emit('setFilelirbaryLeftWidthNew', resultWidth)
          } else {
            vnode.context.$bus.emit('setFilelirbaryLeftWidth', resultWidth)
          }
        }, 15)
      }
      document.onmouseup = function (e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
}

// 微信小程序文本、图片、按钮拖动
const miniProgramDrag = {
  bind(el, binding, vnode, oldVnode) {
    el.onmousedown = e => {
      // e.preventDefault()
      // e.stopPropagation()
      // let offet = $(`.${binding.value}`).offset()
      // 查找兄弟元素
      let currentEl = document.querySelector(`.${binding.value.name}`)
      let allSibling = currentEl.parentNode.children
      // 动态生成对齐线
      let alignTopLeft = `<div class="tfAbsAlignTop"></div><div class="tfAbsAlignLeft"></div>`
      $('body').append(alignTopLeft)

      let parentNode = currentEl.parentNode // 父级节点
      let pHeight = parentNode.clientHeight // 父级元素高度
      let pWidth = parentNode.clientWidth // 父级元素宽度
      let height = currentEl.clientHeight // 当前元素高度
      let width = currentEl.clientWidth // 当前元素宽度
      let left = currentEl.style.left
      let top = currentEl.style.top
      let oldX = e.clientX
      let oldY = e.clientY
      if (left && left.includes('px')) {
        left = parseFloat(left.split('px')[0])
      }
      if (top && top.includes('px')) {
        top = parseFloat(top.split('px')[0])
      }
      let newX = 0
      let newY = 0
      let resultHengLineTop = null // 横线的top
      let resultShuLineLeft = null // 竖线的left
      document.onmousemove = function (e) {
        newX = e.clientX - oldX + left
        newY = e.clientY - oldY + top
        // 获取当前移动元素的 left，top，bottom，right
        let moveEleObj = document.querySelector(`.${binding.value.name}`)
        let offsetMove = $(`.${binding.value.name}`).offset()
        let moveEleTop = offsetMove.top
        let moveHengMiddle = offsetMove.top + moveEleObj.clientHeight / 2
        let moveEleBottom = offsetMove.top + moveEleObj.clientHeight
        let moveEleleft = offsetMove.left
        let moveShuMiddle = offsetMove.left + moveEleObj.clientWidth / 2
        let moveEleRight = offsetMove.left + moveEleObj.clientWidth
        resultHengLineTop = null
        resultShuLineLeft = null
        // 获取最近的兄弟元素
        for (let i = 0; i < allSibling.length; i++) {
          let eleSibling = allSibling[i]
          if (!eleSibling.className.includes(binding.value.name)) {
            let siblingClass = ''
            for (let j = 0; j < eleSibling.classList.length; j++) {
              let sibCla = eleSibling.classList[j]
              if (
                sibCla.includes('text_') ||
                sibCla.includes('button_') ||
                sibCla.includes('pictrue_')
              ) {
                siblingClass = sibCla
              }
            }
            // 获取兄弟元素的 left，top，bottom，right
            let SiblingEleObj = document.querySelector(`.${siblingClass}`)
            let offsetSibling = $(`.${siblingClass}`).offset()
            let SiblingEleTop = offsetSibling.top
            let SiblingHengMiddle = offsetSibling.top + SiblingEleObj.clientHeight / 2
            let SiblingEleBottom = offsetSibling.top + SiblingEleObj.clientHeight
            let SiblingEleleft = offsetSibling.left
            let SiblingShuMiddle = offsetSibling.left + SiblingEleObj.clientWidth / 2
            let SiblingEleRight = offsetSibling.left + SiblingEleObj.clientWidth
            // 处理横线和竖线的显示位置
            // 上上、上中、上下
            if (
              Math.abs(SiblingEleTop - moveEleTop) <= 3 ||
              Math.abs(SiblingEleTop - moveHengMiddle) <= 3 ||
              Math.abs(SiblingEleTop - moveEleBottom) <= 3
            ) {
              resultHengLineTop = SiblingEleTop
            }
            // 中上、中中、中下
            if (
              Math.abs(SiblingHengMiddle - moveEleTop) <= 3 ||
              Math.abs(SiblingHengMiddle - moveHengMiddle) <= 3 ||
              Math.abs(SiblingHengMiddle - moveEleBottom) <= 3
            ) {
              resultHengLineTop = SiblingHengMiddle
            }
            // 下上、下中、下下
            if (
              Math.abs(SiblingEleBottom - moveEleTop) <= 3 ||
              Math.abs(SiblingEleBottom - moveHengMiddle) <= 3 ||
              Math.abs(SiblingEleBottom - moveEleBottom) <= 3
            ) {
              resultHengLineTop = SiblingEleBottom
            }
            // 左左、左中、左右
            if (
              Math.abs(SiblingEleleft - moveEleleft) <= 3 ||
              Math.abs(SiblingEleleft - moveShuMiddle) <= 3 ||
              Math.abs(SiblingEleleft - moveEleRight) <= 3
            ) {
              resultShuLineLeft = SiblingEleleft
            }
            // 中左、中中、中右
            if (
              Math.abs(SiblingShuMiddle - moveEleleft) <= 3 ||
              Math.abs(SiblingShuMiddle - moveShuMiddle) <= 3 ||
              Math.abs(SiblingShuMiddle - moveEleRight) <= 3
            ) {
              resultShuLineLeft = SiblingShuMiddle
            }
            // 右左、右中、右右
            if (
              Math.abs(SiblingEleRight - moveEleleft) <= 3 ||
              Math.abs(SiblingEleRight - moveShuMiddle) <= 3 ||
              Math.abs(SiblingEleRight - moveEleRight) <= 3
            ) {
              resultShuLineLeft = SiblingEleRight
            }
          }
        }
        if (binding.value.field.leftRightDb) {
          // 左右等比
          newX = left
        }
        if (binding.value.field.topBottomDb) {
          // 上下等比
          newY = top
        }
        // 设置横纵坐标
        setTimeout(() => {
          currentEl.style.left = newX + 'px'
          currentEl.style.top = newY + 'px'
          let hengElet = document.querySelector(`.tfAbsAlignTop`)
          if (resultHengLineTop !== null && hengElet) {
            // 如果显示横线
            hengElet.style.top = resultHengLineTop + 'px'
            hengElet.style.left = offsetMove.left + moveEleObj.clientWidth / 2 - 250 + 'px'
            hengElet.style.display = 'block'
          } else if (hengElet) {
            hengElet.style.display = 'none'
          }
          let shuElet = document.querySelector(`.tfAbsAlignLeft`)
          if (resultShuLineLeft !== null && shuElet) {
            // 如果显示竖线
            shuElet.style.left = resultShuLineLeft + 'px'
            shuElet.style.top = offsetMove.top + moveEleObj.clientHeight / 2 - 250 + 'px'
            shuElet.style.display = 'block'
          } else if (shuElet) {
            shuElet.style.display = 'none'
          }
        }, 10)
      }
      document.onmouseup = function (e) {
        // 判断拖动后是否在父级区域内部
        if ((newX < 0 && width - Math.abs(newX) < 0) || (newX > 0 && newX > pWidth)) {
          newX = left
          currentEl.style.left = newX + 'px'
        }
        if ((newY < 0 && height - Math.abs(newY) < 0) || (newY > 0 && newY > pHeight)) {
          newY = top
          currentEl.style.top = newY + 'px'
        }
        // 处理辅助线吸附
        let pOffset = $(`.${currentEl.dataset.pname}`).offset()
        let eleMove = $(`.${binding.value.name}`).offset()
        if (resultHengLineTop !== null) {
          let eleMoveTopMiddle = eleMove.top + currentEl.clientHeight / 2
          if (Math.abs(eleMove.top - resultHengLineTop) <= 4) {
            newY = resultHengLineTop - pOffset.top
          } else if (Math.abs(eleMoveTopMiddle - resultHengLineTop) <= 4) {
            newY = resultHengLineTop - pOffset.top - currentEl.clientHeight / 2
          } else {
            newY = resultHengLineTop - currentEl.clientHeight - pOffset.top
          }
          currentEl.style.top = newY + 'px'
        }
        if (resultShuLineLeft !== null) {
          let eleMoveLeftMiddle = eleMove.left + currentEl.clientWidth / 2
          if (Math.abs(eleMove.left - resultShuLineLeft) <= 4) {
            newX = resultShuLineLeft - pOffset.left
          } else if (Math.abs(eleMoveLeftMiddle - resultShuLineLeft) <= 4) {
            newX = resultShuLineLeft - pOffset.left - currentEl.clientWidth / 2
          } else {
            newX = resultShuLineLeft - currentEl.clientWidth - pOffset.left
          }
          currentEl.style.left = newX + 'px'
        }
        // 设置left、top和元素的宽度的百分比
        let leftPercent = newX / pWidth
        let topPetcent = newY / pHeight
        let widthPercent = currentEl.clientWidth / pWidth
        let heightPercent = currentEl.clientHeight / pHeight
        // 传递给原始数据修改最新值
        setTimeout(() => {
          vnode.context.$bus.emit('sendToMiniTextBtnImgProps', {
            x: newX,
            y: newY,
            name: binding.value.name,
            leftPercent: leftPercent,
            topPetcent: topPetcent,
            widthPercent: widthPercent,
            heightPercent: heightPercent
          })
        }, 10)
        $('.tfAbsAlignLeft').remove()
        $('.tfAbsAlignTop').remove()
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
}
// 微信小程序文本、图片、按钮拖动拖动大小
const resizeProgram = {
  bind(el, binding, vnode, oldVnode) {
    // 图片最小15*15
    // 按钮最小20*20
    // 文本最小宽度30
    el.onmousedown = e => {
      e.preventDefault()
      e.stopPropagation()
      let imgBoxEl = document.querySelector(`.${binding.value.name}__img_box`)
      let parentEl = el.parentNode.parentNode
      let currentEle = el.parentNode.parentNode
      if (binding.value.type === 'button') {
        currentEle = currentEle.querySelector('a')
      } else if (binding.value.type === 'pictrue') {
        currentEle = currentEle.querySelector('a img')
      }
      let oldX = e.clientX // 初始化横坐标
      let oldY = e.clientY // 初始化纵坐标
      let icon = el.className.split(' ')[1]
      let newX = 0
      let newY = 0
      let { x, y } = binding.value
      let { height, width } = binding.value.field
      let newx = x
      let newy = y
      let newheight = height
      let newwidth = width
      document.onmousemove = function (e) {
        newX = e.clientX - oldX
        newY = e.clientY - oldY
        switch (icon) {
          case 'icon_tl':
          case 'icon_tm':
          case 'icon_tr': // 左上角、向上、右上角
            newheight = height - newY
            newy = y + newY
            if (icon === 'icon_tl') {
              // 左上角
              newx = x + newX
              newwidth = width - newX
            } else if (icon === 'icon_tr') {
              // 右上角
              newwidth = width + newX
            }
            break
          case 'icon_br':
          case 'icon_rm':
          case 'icon_bm': // 右下角、向右、向下
            if (icon !== 'icon_rm') {
              // 不是向右
              newheight = height + newY
            }
            if (icon !== 'icon_bm') {
              // 不是向下
              newwidth = width + newX
            }
            break
          case 'icon_bl':
          case 'icon_lm': // 左下角、左边
            newx = x + newX
            newwidth = width - newX
            if (icon === 'icon_bl') {
              newheight = height + newY
            }
            break
        }
        // 控制最小高度和最小宽度
        let minWidht =
          binding.value.type === 'button' ? 20 : binding.value.type === 'pictrue' ? 15 : 30
        let minHeight = binding.value.type === 'button' ? 20 : 15
        if (newwidth < minWidht) {
          newwidth = minWidht
        }
        if (binding.value.type !== 'text') {
          if (newheight < minHeight) {
            newheight = minHeight
          }
        }
        if (binding.value.field.leftRightDb) {
          // 左右等比
          newwidth = width
        }
        if (binding.value.field.topBottomDb) {
          // 上下等比
          newheight = height
        }
        // 最终设置横纵坐标和宽高
        setTimeout(() => {
          currentEle.style.width = newwidth + 'px'
          currentEle.style.height = newheight + 'px'
          if (imgBoxEl) {
            imgBoxEl.style.width = newwidth + 'px'
            imgBoxEl.style.height = newheight + 'px'
          }
          if (binding.value.type === 'button') {
            currentEle.style.lineHeight = newheight + 'px'
          }
          parentEl.style.left = newx + 'px'
          parentEl.style.top = newy + 'px'
        }, 10)
      }
      // 设置left、top和元素的宽度的百分比
      let leftPercent = newX / parentEl.clientWidth
      let topPetcent = newY / parentEl.clientHeight
      let heightPercent = newheight / parentEl.clientHeight
      let widthPercent = newwidth / parentEl.clientWidth
      document.onmouseup = function (e) {
        // 传递给原始数据修改最新值
        setTimeout(() => {
          vnode.context.$bus.emit('sendToMiniTextBtnImgProps', {
            x: newx,
            y: newy,
            height: newheight,
            width: newwidth,
            name: binding.value.name,
            leftPercent: leftPercent,
            topPetcent: topPetcent,
            widthPercent: widthPercent,
            heightPercent: heightPercent
          })
        }, 10)
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
}
export {
  dialogdragwidth,
  draggsubformwidth,
  draggsubformheight,
  clickOutside,
  drag,
  dragKanbanwidth,
  businessdragwidth,
  trim,
  stopNumberScroll,
  fileLibraryDragwidth,
  miniProgramDrag,
  resizeProgram
}

export default {
  dialogdragwidth,
  draggsubformwidth,
  draggsubformheight,
  clickOutside,
  drag,
  dragKanbanwidth,
  businessdragwidth,
  trim,
  stopNumberScroll,
  fileLibraryDragwidth,
  miniProgramDrag,
  resizeProgram
}
